import React, { useState } from 'react';
import {
  Box,
  CustomTheme,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ContentContainer } from '../../components/ContentContainer';
import { Outlet } from 'react-router';
import { SideBar } from '../../components/SideBar';
import MenuIcon from '@mui/icons-material/Menu';

export const MainLayout: React.FC = (): JSX.Element => {
  const theme = useTheme<CustomTheme>();
  const isMobileDevice = useMediaQuery(
    `(max-width: ${theme.portal.sidebar.mobileMenuAt})`
  );

  const [showMobileMenu, setShowMobileMenu] = useState<boolean>(false);

  const showMenu = (): void => {
    setShowMobileMenu(true);
  };

  const hideMenu = (): void => {
    setShowMobileMenu(false);
  };

  return (
    <Box>
      <SideBar
        isMobileDevice={isMobileDevice}
        showMobileMenu={showMobileMenu}
        onClose={hideMenu}
      />
      <ContentContainer
        sidebarMenuOffset={
          isMobileDevice ? undefined : theme.portal.sidebar.width
        }
      >
        <Outlet />
      </ContentContainer>

      {isMobileDevice && (
        <IconButton
          sx={{
            position: 'fixed',
            top: '10px',
            right: '10px',
          }}
          onClick={showMenu}
        >
          <MenuIcon />
        </IconButton>
      )}
    </Box>
  );
};
